export default __webpack_public_path__ + "assets/2a5f93.svg";